import React,{useContext,useEffect, useState, useRef,useReducer} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../svg/svgIcons";
import { InfinitySpin } from 'react-loader-spinner';
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { MultiSelect } from 'primereact/multiselect';
import { useMaintenanceTypes } from '../../utils/useMaintenanceTypes';
import { useMachineCards } from '../../utils/useMachineCards';
import { uiT as t } from '../../utils/uiTranslate';

export default function MaintenanceRecordAdd({maintenance_type}) {
    
    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {toast,openFavoriteDialog,setFastView,setDialogText,setVisible} = useContext(UtilContext);
    const { maintenanceTypes: allMaintenanceTypes, loading: loadingTypes } = useMaintenanceTypes();
    const { machineCards } = useMachineCards();
    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);
    const fileListRef = useRef(null);

    const NONE_PART = "__NONE__"; // reprezentuje prázdnu/NULL súčasť

    const [formMaintenanceType,setFormMaintenanceType] = useState(maintenance_type);
    const [machineType,setMachineType] = useState([]);
    const [maintenanceTypes,setMaintenanceTypes] = useState([]);

    useEffect(() => {
        setMaintenanceTypes(allMaintenanceTypes);
    }, [allMaintenanceTypes]);
    const [companyContactsFallback, setCompanyContactsFallback] = useState([]);
    const [loadingContacts, setLoadingContacts] = useState(true);
    const effectiveMaintenanceCompanyContacts = (state.maintenance_company_contacts || []).length ? (state.maintenance_company_contacts || []) : companyContactsFallback;
    const [companyContacts, setCompanyContacts] = useState(effectiveMaintenanceCompanyContacts);

    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add maintenance"))?false:true);

    const [fileList, setFileList] = useState([]);

    useEffect(() => {
        if ((state.maintenance_company_contacts || []).length > 0) {
            setLoadingContacts(false);
            return;
        }
        getRequest("/api/company_contacts?minimal=1&module=maintenance")
            .then((r) => {
                const list = Array.isArray(r?.data) ? r.data : (Array.isArray(r) ? r : []);
                setCompanyContactsFallback(list);
            })
            .catch(() => {})
            .finally(() => setLoadingContacts(false));
    }, [state.maintenance_company_contacts?.length]);

    // Pri otvorení s predvyplneným maintenance_type (zo zoznamu podľa stavu) nastavíme companyContacts podľa company_id a lecturer_id, aby sa zobrazil Servisný technik
    useEffect(() => {
        const mt = formMaintenanceType ?? maintenance_type;
        if (!mt?.company_id || mt.lecturer_id === undefined || mt.lecturer_id === null || mt.lecturer_id === '') return;
        const base = effectiveMaintenanceCompanyContacts.filter(c => String(c.company_id) === String(mt.company_id));
        const lec = Number(mt.lecturer_id);
        const filtered = lec === 1 ? base.filter(c => c.employee_id != null) : base.filter(c => c.employee_id == null);
        setCompanyContacts(filtered);
    }, [maintenance_type?.company_id, maintenance_type?.lecturer_id, formMaintenanceType?.company_id, formMaintenanceType?.lecturer_id, effectiveMaintenanceCompanyContacts]);

    const loadingData = loadingTypes || loadingContacts;

    function addNewMaintenanceType(){
        dispatch({type:'create_new_tab',name: t('Maintenance.NewScheduledTask'), translationKey: 'Maintenance.NewScheduledTask', legacyLabel: t('Maintenance.NewScheduledTask'),page:'MaintenanceRecordAdd',props:{maintenance_type: null,type:'add'},mask:'mntn019'})
    }
    
    function copyMaintenanceType(){
        dispatch({type:'create_new_tab',name: t('Maintenance.NewScheduledTask'), translationKey: 'Maintenance.NewScheduledTask', legacyLabel: t('Maintenance.NewScheduledTask'),page:'MaintenanceRecordAdd',props:{maintenance_type: formik.values,type:'add'},mask:'mntn019'})
    }

    const normalizePart = (value) => (value ?? "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const isActiveCard = (row) => !row?.deactivation_date;

    /** Rovnaká logika ako pri serv. firme v zoznamoch: riadok môže mať lokálne company_id alebo zodpovedať centrálnej firme z typu úkonu. */
    function scheduledCardMatchesCompanyFilter(card, selectedCompanyId) {
        if (selectedCompanyId === undefined || selectedCompanyId === null || String(selectedCompanyId).trim() === '') return false;
        if (String(card.company_id ?? '') === String(selectedCompanyId)) return true;
        const mt = card.maintenance_type;
        if (mt?.use_central_service_person && mt.central_company_id != null && String(mt.central_company_id) === String(selectedCompanyId)) {
            return true;
        }
        return false;
    }

    const validate = values => {
        const errors = {};
        if (!values.maintenance_type_id) {
            errors.maintenance_type_id = t('Common.RequiredField');
            return errors;
        }
        if (!values.company_id) {
            errors.company_id = t('Common.RequiredField');
            return errors;
        }
        if (!values.company_contact_id) {
            errors.company_contact_id = t('Common.RequiredField');
            return errors;
        }
        if ((values.machines || []).length > 0 && availableParts.length === 0) {
            errors.machines = t('MaintenanceRecordAdd.Text.Vybrane_stroje_nemaju_spolocnu_sucast_Zmen_vyber');
            return errors;
        }
        if ((values.machines || []).length > 0 && !values.machine_part_key) {
            errors.machine_part_key = t('Common.RequiredField');
            return errors;
        }
        if (protocolRequired && fileList.length === 0) {
            errors.files = t('Common.RequiredField');
        }
        return errors;
    };

    const formik = useFormik({
        initialValues: formMaintenanceType==null?{
            maintenance_type_id: '',  machine_part_key: '',last_execution_date: '',machines:[],description:'',company_id:'',lecturer_id:'',company_contact_id:''}
            :{
            ...formMaintenanceType,
            lecturer_id: formMaintenanceType.lecturer_id ?? '',
            machine_part_key: formMaintenanceType.machine_part_key ?? (formMaintenanceType.machine_part ? String(formMaintenanceType.machine_part).trim() || NONE_PART : NONE_PART)
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let key in values) {
                if (key === "machines") {
                    const my_machines = values.machines.map(machine => machine.id);
                    for (let i = 0; i < my_machines.length; i++) formData.append("machines[]", my_machines[i]);
                    continue;
                }
                if (key === "machine_part_key") {
                    continue;
                }
                formData.append(key, values[key] != null ? values[key] : "");
            }
            const machinePartToSend = values.machine_part_key === NONE_PART ? "" : values.machine_part_key;
            formData.append("machine_part", machinePartToSend);
            /*for (var pair of formData.entries()) {
                console.log(pair[0]+ ', ' + pair[1]); 
            }*/
            for(let i = 0;i<fileList.length;i++){
                formData.append('files[]',fileList[i]);
            }
            setDialogText(t('Common.Saving'));
            setVisible(true);
            postRequest('/api/maintenance_scheduled_records', formData, true)
            .then((response) => {
                setFileList([]);
                    if (fileListRef.current) fileListRef.current.value = "";
                    if (closeTab) {
                        if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                        formik.resetForm();
                        setMachineType("");
                        setMaintenanceTypes(allMaintenanceTypes);
                        setCompanyContacts(effectiveMaintenanceCompanyContacts);
                    } else {
                        formik.setFieldValue("last_execution_date", "");
                        formik.setFieldValue("machines", []);
                        formik.setFieldValue("description", "");
                    }
                    setCloseTab(false);
                    toast?.current?.show({severity: 'info',summary: t('Common.Confirmed'),life: 3000,detail: t('Common.Toast.RecordSavedDetail')});
                    setVisible(false);
            })
            .catch((reason) => {
                setVisible(false);
                alert(t('Common.Toast.ActionFailedDetail'));
            });
        },
    });

    function filterMaintenanceTypes(machineTypeId){
        setMachineType(machineTypeId);
        if(machineTypeId=="")setMaintenanceTypes(allMaintenanceTypes);
        else setMaintenanceTypes(allMaintenanceTypes.filter(mt => mt.machine_type_id === parseInt(machineTypeId)));
    }

    const sortByOptionalName = (arr, getName = (x) => x?.name) => {
        return [...(arr || [])]
        .map((item, idx) => ({ item, idx, name: getName(item) }))
        .sort((a, b) => {
            const an = (a.name ?? "").toString().trim();
            const bn = (b.name ?? "").toString().trim();

            if (!an && !bn) return a.idx - b.idx;     // obom chýba name -> pôvodné poradie
            if (!an) return 1;                         // a bez name -> na koniec
            if (!bn) return -1;                        // b bez name -> na koniec

            return an.localeCompare(bn, "sk");         // abecedne
        })
        .map((x) => x.item);
    };

    const handleFileChange = (event) => {
        setFileList(Array.from(event.target.files || []));
    };

    function changeMaintenanceType(maintenance_type_id){
        formik.setFieldValue('maintenance_type_id',maintenance_type_id);
        formik.setFieldValue('machine_part_key', '');
        formik.setFieldValue('company_id','');
        formik.setFieldValue('company_contact_id','');
        formik.setFieldValue("machines",[]);
    }

    function changeCompany(company_id) {
         const filtered = effectiveMaintenanceCompanyContacts.filter(
            contact => String(contact.company_id) === String(company_id)
        );
        formik.setFieldValue('company_id', company_id);
        setCompanyContacts(filtered);
        formik.setFieldValue('lecturer_id', '');
        formik.setFieldValue('company_contact_id', '');
        formik.setFieldValue('machine_part_key', '');
        formik.setFieldValue("machines", []);
    }

    const availableParts = React.useMemo(() => {
        const typeId = Number(formik.values.maintenance_type_id || 0);
        const companyId = String(formik.values.company_id || "");
        const selectedMachines = formik.values.machines || [];
        if (!typeId || !companyId) return [];
        // helper: vráti Map(norm -> { key, label }) pre konkrétny stroj
        const partsForMachine = (machineId) => {
            const wrap = (machineCards ?? []).find(m => String(m.id) === String(machineId));
            if (!wrap) return new Map();
            const map = new Map();
            (wrap.machine_card || []).forEach(card => {
                if (!isActiveCard(card)) return;
                if (Number(card.maintenance_type_id) !== typeId) return;
                if (!scheduledCardMatchesCompanyFilter(card, companyId)) return;
                const raw = (card.machine_part ?? "").toString().trim();
                const key = raw ? raw : NONE_PART;
                const norm = raw ? normalizePart(raw) : NONE_PART;
                map.set(norm, { key, label: raw ? raw : t('MaintenanceRecordAdd.Text.bez_sucasti') });
            });
            return map;
        };

        let resultMap = new Map();

        // 🔁 AK SÚ VYBRANÉ STROJE → PRIENIK
        if (selectedMachines.length > 0) {
            selectedMachines.forEach((m, index) => {
                const machineId = m.id ?? m;
                const machineParts = partsForMachine(machineId);
                if (index === 0) {
                    // prvý stroj = základ
                    resultMap = new Map(machineParts);
                } else {
                    // prienik s ďalším strojom
                    for (let key of resultMap.keys()) {
                        if (!machineParts.has(key)) {
                            resultMap.delete(key);
                        }
                    }
                }
            });
        }
        // 🔁 AK NIE SÚ VYBRATÉ STROJE → UNION (pôvodné správanie)
        else {
            machineCards.forEach(m => {
                const machineParts = partsForMachine(m.id);
                machineParts.forEach((v, k) => {
                    if (!resultMap.has(k)) resultMap.set(k, v);
                });
            });
        }

        return Array.from(resultMap.values()).sort((a, b) => a.label.localeCompare(b.label, "sk"));
    }, [machineCards,formik.values.maintenance_type_id,formik.values.company_id,formik.values.machines]);

    useEffect(() => {
        if (availableParts.length === 1 && !formik.values.machine_part_key) {
            formik.setFieldValue("machine_part_key", availableParts[0].key);
        }
        // ak zvolená súčasť nie je v dostupných → zruš
        if (formik.values.machine_part_key && !availableParts.some(p => p.key === formik.values.machine_part_key)) {
            formik.setFieldValue("machine_part_key", "");
            formik.setFieldTouched("machine_part_key", false, false);
        }
        // ak stroje sú vybrané a prienik je prázdny → zruš súčasť (kvôli starým hodnotám)
        if ((formik.values.machines || []).length > 0 && availableParts.length === 0 && formik.values.machine_part_key) {
            formik.setFieldValue("machine_part_key", "");
            formik.setFieldTouched("machine_part_key", false, false);

        }
    }, [availableParts]);

    const eligibleMachines = React.useMemo(() => {
        const typeId = Number(formik.values.maintenance_type_id || 0);
        const companyId = String(formik.values.company_id || "");
        if (!typeId || !companyId) return [];

        // stroje ktoré majú v karte aktívny záznam pre (typeId + companyId) na hocijakú súčasť
        return sortByOptionalName(
            (machineCards ?? [])
            .filter(machine =>
                (machine.machine_card || []).some(card => {
                if (!isActiveCard(card)) return false;
                if (Number(card.maintenance_type_id) !== typeId) return false;
                if (!scheduledCardMatchesCompanyFilter(card, companyId)) return false;
                return true;
                })
            )
            .map(m => ({ name: m.name, id: m.id }))
        );
    }, [machineCards, formik.values.maintenance_type_id, formik.values.company_id]);

    const protocolRequired = React.useMemo(() => {
        const typeId = Number(formik.values.maintenance_type_id || 0);
        const companyId = String(formik.values.company_id || "");
        const partKey = formik.values.machine_part_key;
        const selected = formik.values.machines || [];
        if (!typeId || !companyId || !partKey || selected.length < 1) return false;

        const partNorm = partKey === NONE_PART ? NONE_PART : normalizePart(partKey);
        // ak aspoň jeden vybraný stroj má v karte pre túto kombináciu required_attachment=1 => povinné
        return selected.some((m) => {
            const machineId = m?.id ?? m; // (pre istotu keby prišlo len id)
            const wrap = (machineCards ?? []).find(x => String(x.id) === String(machineId));
            if (!wrap) return false;
            return (wrap.machine_card || []).some((card) => {
            if (!isActiveCard(card)) return false;
            if (Number(card.maintenance_type_id) !== typeId) return false;
            if (!scheduledCardMatchesCompanyFilter(card, companyId)) return false;

            const raw = (card.machine_part ?? "").toString().trim();
            const norm = raw ? normalizePart(raw) : NONE_PART;
            if (norm !== partNorm) return false;

            return Number(card.required_attachment) === 1;
            });
        });
    }, [machineCards,formik.values.maintenance_type_id,formik.values.company_id,formik.values.machine_part_key,formik.values.machines]);

    const LECTURER_EXTERNAL = t('Common.ServiceCompanyEmployee');
    const LECTURER_INTERNAL = t('Common.InternalEmployee');

    const lecturers = [
        { id: 0, name: LECTURER_EXTERNAL },
        { id: 1, name: LECTURER_INTERNAL },
    ];

    function changeLecturer(lecturer_id){
        const lec = lecturer_id === "" || lecturer_id == null ? "" : Number(lecturer_id);
        formik.setFieldValue('lecturer_id', lecturer_id);
        const companyId = formik.values?.company_id;
        const base = effectiveMaintenanceCompanyContacts.filter(c => String(c.company_id) === String(companyId));
        const filtered = lec === "" ? base : lec === 1 ? base.filter(c => c.employee_id != null) : base.filter(c => c.employee_id == null);
        setCompanyContacts(filtered);
        formik.setFieldValue('company_contact_id', '');
        formik.setFieldValue('machine_part_key', '');
        formik.setFieldValue('machines', []);
    }

    if (loadingData) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[calc(100vh-177px)] bg-gray-100 gap-4">
                <InfinitySpin width="120" color="#333" />
                <span className="text-gray-700">{t('Common.LoadingData')}</span>
            </div>
        );
    }

    return ( 
        <>
           <div className='w-full h-10 flex flex-row bg-[#333]'>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewMaintenanceType()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyMaintenanceType()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => openFavoriteDialog(t('MaintenanceRecordAdd.Text.Novy_pl_ukon'),"MaintenanceRecordAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("MaintenanceRecordAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        <div className='overflow-y-auto h-[calc(100vh-177px)] bg-gray-100'>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-white rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.ZAZNAMENAT_NOVY_PLANOVANY_UKON')}</h1>
                    <div>
                        <label
                            htmlFor="machineType"
                            className="block text-md font-semibold text-gray-800"
                        >{t('MachineList.Column.MachineTypeName')}</label>
                        <select 
                        name='machineType'
                        onChange={(e) => filterMaintenanceTypes(e.target.value)} value={machineType}
                        className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                          <option value="">{t('Common.All')}</option>
                          {sortByOptionalName(state.machine_types).map((machine_type) => (
                            <option key={machine_type.id} value={machine_type.id}>{machine_type.name}</option>
                            ))}
                        </select>
                    </div>
                        <div>
                        <label
                            htmlFor="maintenance_type_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Nazov_planovaneho_ukonu')}</label>
                        <select 
                        required
                        name="maintenance_type_id"
                        onChange={(e) => changeMaintenanceType(e.target.value)} value={formik.values.maintenance_type_id} 
                        className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                          <option value="">{t('Ui.R67.Vyber_pl_ukon')}</option>
                          {sortByOptionalName(maintenanceTypes).map((maintenance_type) => (
                            <option key={maintenance_type.id} value={maintenance_type.id}>{maintenance_type.name}</option>
                            ))}
                        </select>
                        </div>
                      <div>
                        <label
                            htmlFor="last_execution_date"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Datum_vykonania')}</label>
                        <input
                            name='last_execution_date'
                            type="date" required
                            onChange={formik.handleChange} value={formik.values.last_execution_date}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div> 
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Note')}</label>
                        <textarea
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>
                        <div>
                            <label
                                htmlFor="company_id"
                                className="block text-md font-semibold text-gray-800"
                            >
                            Serv. firma
                            </label>
                            <select required
                            name='company_id'
                            onChange={(e) => changeCompany(e.target.value)} value={formik.values?.company_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_serv_firmu_2')}</option>
                            {sortByOptionalName(state.maintenance_companies).map((company) => (
                                <option key={company.id} value={company.id}>{company.name}</option>
                            ))}
                            </select>
                        </div> 
                        {(formik.values?.company_id!="" && formik.values?.company_id!=null)  && <><div>
                            <label
                                htmlFor="lecturer_id"
                                className="block text-md font-semibold text-gray-800"
                            >
                            Druh technika
                            </label>
                            <select
                            name='lecturer_id'
                            onChange={(e) => changeLecturer(e.target.value)} value={formik.values?.lecturer_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_druh_technika')}</option>
                            {lecturers.map((lecturer) => (
                                <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                            ))}
                            </select>
                        </div>
                        {(formik.values?.lecturer_id === 0 || formik.values?.lecturer_id === 1 || formik.values?.lecturer_id === "0" || formik.values?.lecturer_id === "1") && <><div>
                            <label
                                htmlFor="company_contact_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.ServiceTechnician')}</label>
                            <select required
                            name='company_contact_id'
                            onChange={(e) => {
                                formik.handleChange(e);
                                formik.setFieldValue("machine_part_key", "");
                                formik.setFieldValue("machines", []);
                            }}
                            value={formik.values?.company_contact_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_kont_osobu')}</option>
                            {sortByOptionalName(companyContacts, c => c?.employee?.name || c?.name).map((contact) => (
                                <option key={contact.id} value={contact.id}>{contact?.employee?.name || contact?.name}</option>
                                ))}
                            </select>
                        </div>
                        {(formik.values?.company_contact_id !== "" && formik.values?.company_contact_id != null) && (
                            <div>
                                <label htmlFor="employees" className="block text-md font-semibold text-gray-800">
                                Stroje
                                </label>
                                <MultiSelect
                                required
                                value={formik.values.machines}
                                onChange={(e) => {
                                    formik.setFieldValue("machines", e.value);
                                    formik.setFieldValue("machine_part_key", "");
                                    formik.setFieldTouched("machine_part_key", false, false);
                                }}
                                options={eligibleMachines}
                                optionLabel="name"
                                filter
                                placeholder={t('MaintenanceRecordAdd.Text.Vyber_stroje')}
                                className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                />
                                {formik.values.machines.length > 0 && availableParts.length === 0 && (
                                    <div className="mt-2 text-sm text-red-600">
                                        Vybrané stroje nemajú spoločnú súčasť. Zmeň výber strojov.
                                    </div>
                                )}
                                {formik.errors.machines ? (
                                <div className="mt-2 text-sm text-red-600">{formik.errors.machines}</div>
                                ) : null}
                                <div>
                                <label className="block text-md my-2 font-semibold text-gray-800">
                                    POČET: {formik.values.machines.length}
                                </label>
                                </div>
                            </div>
                        )}
                        {formik.values?.machines?.length > 0 && availableParts.length > 0 && (
                            <div>
                                <label htmlFor="machine_part_key" className="block text-md font-semibold text-gray-800">{t('Common.MachinePart')}</label>
                                <select
                                required
                                id="machine_part_key"
                                name="machine_part_key"
                                value={formik.values.machine_part_key}
                                onChange={(e) => {
                                    formik.setFieldValue("machine_part_key", e.target.value);
                                }}
                                onBlur={formik.handleBlur}
                                className={`bg-white block w-full px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40
                                    ${formik.touched.machine_part_key && formik.errors.machine_part_key ? "border-red-500" : "border-gray-300"}
                                `}
                                >
                                <option value="">{t('Ui.R67.Vyber_sucast_stroja')}</option>
                                {availableParts.map(p => (
                                    <option key={p.key} value={p.key}>{p.label}</option>
                                ))}
                                </select>
                                {formik.errors.machine_part_key && (
                                    <div className="mt-1 text-sm text-red-600">{formik.errors.machine_part_key}</div>
                                )}
                            </div>
                        )}
                        </>}</>}
                        <div>
                        <label
                            htmlFor="files"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Protokol
                        </label>
                          <input
                            required={protocolRequired}
                            accept='image/*,application/pdf'
                            name='files'
                            ref={fileListRef}
                            onChange={handleFileChange}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            type='file'
                            multiple="multiple"
                            id='file'
                            />
                        {protocolRequired && (
                            <div className="mt-1 text-xs text-gray-500">
                                Príloha je povinná, lebo aspoň jeden vybraný stroj má v karte úkonu nastavenú povinnú prílohu.
                            </div>
                        )}
                        {formik.errors.files && (
                            <div className="mt-1 text-sm text-red-600">{formik.errors.files}</div>
                        )}
                        </div>
                        <button type='submit' ref={submitRef}></button>
            </div>
            </div>
            </div> 
             </form>
            </div>
            </> 
            );

}